<script setup>
import LoadingSpinner from "@js/components/LoadingSpinner.vue";
import DataTableLayout from "@js/components/tables/DataTableLayout.vue";
import CrossIconCell from "@js/components/tables/cells/CrossIconCell.vue";
import PillCell from "@js/components/tables/cells/PillCell.vue";
import TextCellV2 from "@js/components/tables/cells/TextCellV2.vue";
import { useDataTable } from "@js/utils/dataTable";
import { useRoute } from "@js/utils/route";
import { createColumnHelper } from "@tanstack/vue-table";
import { h } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { userSessionKey, cms } = defineProps({
  userSessionKey: {
    type: String,
    required: false,
  },
  cms: {
    type: String,
    required: false,
  },
});

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
  loading,
  table,
  count,
  globalFilter,
  filters,
  availableFilters,
  setGlobalFilter,
  setFilters,
} = useDataTable({
  columns: [
    columnHelper.accessor(() => null, {
      id: "name",
      header: () => t("label.name"),
      cell: (props) =>
        h(TextCellV2, {
          text: props.row.original.name,
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "cms",
      header: () => t("label.cms"),
      cell: (props) =>
        h(PillCell, {
          pillValue:
            props.row.original.cms === "magento1"
              ? "Magento 1"
              : props.row.original.cms === "magento2"
                ? "Magento 2"
                : props.row.original.cms === "prestashop"
                  ? "Prestashop"
                  : props.row.original.cms === "wordpress"
                    ? "Wordpress"
                    : props.row.original.cms === "shopify"
                      ? "Shopify"
                      : "Custom",
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "version",
      header: () => t("label.datakeplerModuleVersion"),
      cell: (props) =>
        props.row.original.version
          ? h(TextCellV2, {
              text: props.row.original.version,
            })
          : h(CrossIconCell),
    }),
  ],
  url: route("front.projectManagement.customer.postDev"),
  userSessionKey: userSessionKey,
  data: {
    cms,
  },
  columnVisibility: {
    cms: !cms,
  },
});
</script>

<template>
  <LoadingSpinner v-if="loading" />

  <div v-else>
    <DataTableLayout
      :table="table"
      :count="count"
      :global-filter="globalFilter"
      :filters="filters"
      :available-filters="availableFilters"
      :set-filters="setFilters"
      :set-global-filter="setGlobalFilter"
    />
  </div>
</template>
